import React from 'react'
import { useTranslation } from 'react-i18next'
import ordersColorIcon from '../../assets/images/orders-color.svg'

interface OrderConfirmationActionsProps {
  onNewOrder: () => void
  onPrint: () => void
  isRTL: boolean
  showPrintButton: boolean
}

const OrderConfirmationActions: React.FC<OrderConfirmationActionsProps> = ({
  onNewOrder,
  onPrint,
  isRTL,
  showPrintButton
}) => {
  const { t } = useTranslation()
  return (
    <div className="w-full max-w-[480px] flex flex-col justify-center items-center gap-2">
      {/* New Order Button - Teal/Blue-green */}
      <button
        onClick={onNewOrder}
        className="w-full h-[50px] bg-flutter-button hover:opacity-90 rounded-[10px] shadow-md inline-flex justify-center items-center gap-2 transition-colors"
      >
        <span className="text-white text-base font-semibold font-['IBM_Plex_Sans_Arabic']">
          {t('order.new_order')}
        </span>
      </button>

      {/* Print Button - White */}
      {showPrintButton && (
        <button
          onClick={onPrint}
          className="w-full h-[50px] bg-white rounded-[10px] border border-gray-200 inline-flex justify-center items-center gap-2 hover:bg-gray-50 transition-colors"
        >
          <img src={ordersColorIcon} alt="" className="w-5 h-5" style={{ filter: 'brightness(0) saturate(100%)' }} />
          <span className="text-black text-base font-medium font-['IBM_Plex_Sans_Arabic']">
            {t('order.print')}
          </span>
        </button>
      )}
    </div>
  )
}

export default OrderConfirmationActions

